module.exports = __webpack_public_path__ + "static/interstate-97c1af9b8513ca915c5237ea238b69c7.woff";